module.exports = __webpack_public_path__ + "static/media/flood-green.70107dbb.svg";